module.exports = __webpack_public_path__ + "img/epr-article-top-img_small.c43b1f2f.webp";